// * Bootstrap libraries
import './_bootstrap';

(function () {
  'use strict';

  // returns true if an element contains visible text (ignores whitespace)
  function hasVisibleText(el) {
    if (!el) return false;
    // grab textContent from children and self, trim whitespace
    const text = el.textContent || '';
    if (text.trim().length) return true;

    // if children might include images or other meaningful nodes, check them too:
    for (const child of el.children) {
      // images, svgs, or elements with aria-label might count as content:
      if (child.tagName === 'IMG' || child.querySelector('img') || child.getAttribute('aria-label')) {
        return true;
      }
      // also check child text
      if ((child.textContent || '').trim().length) return true;
    }
    return false;
  }

  function updateCaptionClasses(container) {
    // accept optional container to scope (defaults to document)
    const scope = container || document;
    const captions = scope.querySelectorAll('.carousel-caption');

    captions.forEach(caption => {
      // check for real text in immediate headings/paragraphs or caption itself
      const heading = caption.querySelector('h5, h4, h3, h2, .caption-title');
      const paragraph = caption.querySelector('p, .caption-text');

      const hasContent =
        hasVisibleText(heading) ||
        hasVisibleText(paragraph) ||
        // fallback: maybe caption has text directly
        hasVisibleText(caption);

      if (hasContent) {
        caption.classList.add('has-caption');
        caption.classList.remove('no-caption');
      } else {
        caption.classList.add('no-caption');
        caption.classList.remove('has-caption');
      }
    });
  }

  // Initial run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    updateCaptionClasses(document);

    // If using Bootstrap or dynamic content that changes later (e.g., slides are injected),
    // observe the document for changes and re-run on relevant mutations.
    const observer = new MutationObserver(muts => {
      let recheck = false;
      for (const m of muts) {
        // quick heuristic: if childList changed or characterData in nodes inside .carousel-caption
        if (m.type === 'childList' || m.type === 'characterData') {
          recheck = true;
          break;
        }
      }
      if (recheck) updateCaptionClasses(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // If you prefer not to use MutationObserver in older browsers, you can
    // also re-run updateCaptionClasses() after your slide content gets loaded.
  });

  // Optional: If you want to re-check when slides change (Bootstrap carousel 'slide' event)
  if (window.jQuery) {
    // for Bootstrap 4/5 (jQuery present)
    (function ($) {
      $(document).on('slid.bs.carousel', '.carousel', function () {
        updateCaptionClasses(this);
      });
      $(document).on('slide.bs.carousel', '.carousel', function () {
        updateCaptionClasses(this);
      });
    })(window.jQuery);
  } else {
    // For non-jQuery bootstrap, or if you have code toggling slides, call updateCaptionClasses(container)
    // after slide replacement to re-evaluate the caption.
  }

})();

